import React from 'react';
import { Box, Typography } from '@mui/material';
import { getDataValue, latestEntry } from '../utils';

const Settings = {
  Name: 'Json',
  Display: true,
  options: {
    view: null,
    settings: [
      { id: 'title', type: 'text', name: 'Title' },
      { id: 'dataId', type: 'text', name: 'Data path', placeholder: 'Leave blank to show body' },
      { id: 'emptyText', type: 'text', name: 'Empty text', default: 'No data' },
    ],
    grid: true,
  },
};

function prettyJson(value, fallback) {
  if (value === null || value === undefined || value === '') return fallback;

  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return fallback;
  }
}

const View = ({ DeviceData, Settings: userSettings = {} }) => {
  const entry = latestEntry(DeviceData);
  const value = userSettings.dataId ? getDataValue(entry, userSettings.dataId) : entry?.body;

  return (
    <Box>
      {userSettings.title ? (
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>{userSettings.title}</Typography>
      ) : null}
      <Box component="pre" sx={{ m: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {prettyJson(value, userSettings.emptyText || 'No data')}
      </Box>
    </Box>
  );
};

export default {
  Settings,
  View,
};
